export default "__VITE_PUBLIC_ASSET__2c7d1a93__"